<script setup lang="ts">
    import WorksitePhase from '~/app/worksite/models/WorksitePhase';
    import PlanningItem from '~/app/planning/models/PlanningItem';

    const props = defineProps<{
        planningItem: PlanningItem;
        model: WorksitePhase;
        displayTime: boolean;
    }>();
</script>

<template>
    <div
        :id="model.getInternalId()"
        class="p-2 mb-1 text-xs text-gray-800 bg-white border rounded border-neutral-200"
        @click.prevent="model.edit()"
    >
        <span
            class="block text-xs text-gray-600"
            v-if="model.worksite"
        >
            {{ model.worksite.title }}
        </span>
        <span class="block text-sm">
            {{ model.title }}
        </span>
    </div>
</template>
